// desk-model — API client wrappers + view-model mappers for The Desk.
// Maps real backend queue shapes into the prototype's AskCard view-models
// so the ported components stay presentational.

import { api } from './api.js';
import { streamPost } from './sse.js';

/* ---------- API client ---------- */

export function fetchQueue(projectId) {
  return api('/api/projects/' + projectId + '/queue');
}
export function undoAnswer(projectId, turnId) {
  return api('/api/projects/' + projectId + '/queue/' + turnId + '/answer', { method: 'DELETE' });
}
export function answerAsk(projectId, turnId, payload, onEvent) {
  return streamPost('/api/projects/' + projectId + '/queue/' + turnId + '/answer', payload, onEvent);
}

/* ---------- view-model mappers ---------- */

// blocksLabel — the small urgency label on the ask head.
export function blocksLabel(urgency, section) {
  if (urgency === 'blocks') return 'BLOCKS' + (section ? ' · ' + section : '');
  if (urgency === 'feeds') return 'FEEDS' + (section ? ' · ' + section : '');
  return 'WHEN YOU CAN';
}

// toAskView — backend queue item → AskCard view-model.
export function toAskView(item, { answered } = {}) {
  const ask = item.ask || {};
  return {
    id: item.askId,
    turnId: item.askId,
    threadId: item.threadId,
    agent: item.agent,
    type: ask.type || 'fork',
    q: ask.text,
    why: item.summary || '',
    urgency: ask.urgency || null,
    section: ask.section || null,
    blocksLabel: blocksLabel(ask.urgency, ask.section),
    tone: ask.urgency === 'blocks' ? 'hot' : ask.urgency === 'feeds' ? 'cool' : '',
    options: (ask.options || []).map(o => o.label),
    work: ask.work || null,
    items: (ask.items || []).map((it, i) => ({ id: String(i), kind: it.kind, short: it.short, cap: it.caption })),
    answer: answered ? ask.answer : null,
    answeredAt: item.answeredAt || (ask && ask.answeredAt) || null,
    raisedAt: item.raisedAt,
  };
}

// toAnswerPayload — AskCard answer (raw, shape-specific) → backend typed payload.
export function toAnswerPayload(type, raw) {
  const r = raw || {};
  switch (type) {
    case 'fork':
      return r.freeText ? { kind: 'fork', freeText: r.freeText } : { kind: 'fork', choice: r.choice };
    case 'review':
      return { kind: 'review', verdict: r.verdict, notes: r.notes || '' };
    case 'pick':
      return r.none ? { kind: 'pick', none: true } : { kind: 'pick', keptItemIds: r.keptItemIds || [] };
    case 'unblock':
      return r.quickChoice ? { kind: 'unblock', quickChoice: r.quickChoice } : { kind: 'unblock', freeText: r.freeText };
    default:
      return { kind: type, ...r };
  }
}
